import { render, staticRenderFns } from "./customerInfo.vue?vue&type=template&id=535c7675&scoped=true&"
import script from "./customerInfo.vue?vue&type=script&lang=js&"
export * from "./customerInfo.vue?vue&type=script&lang=js&"
import style0 from "./customerInfo.vue?vue&type=style&index=0&id=535c7675&prod&lang=less&scoped=true&"
import style1 from "./customerInfo.vue?vue&type=style&index=1&id=535c7675&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535c7675",
  null
  
)

export default component.exports